// TODO: bundle apollo functions

import { useQuery, useResult } from '@vue/apollo-composable';
import { useRouter } from 'vivat';

import gql from 'graphql-tag';
import {
  reactive, watch, computed, ref,
} from '@vue/composition-api';

const me = reactive({
  id: -1,
  name: '',
  avatarPath: null as string | null,
  email: '',
  telephone: '',
  // employeeCode: '',
  role: '',
  permissions: [],
  hubId: -1,
  hub: {
    id: -1,
    name: '',
    code: '',
    hubType: 'MAIN',
    areas: [],
    lat: 0,
    long: 0,
  },
  company: {
    id: -1,
    name: '',
    subdomain: '',
    package: '',
    userType: '',
    remarks: '',

    startDate: '',
    expireDate: '',

    logoUrl: '/logo_fast.svg',
    backgroundUrl: '/img/background/bg-tms.png',

    maxStorage: '',

    taxId: '',
    billingAddress: '',
    address: {
      province: { id: '', nameInThai: '' },
      district: { id: '', nameInThai: '' },
      subdistrict: { id: '', nameInThai: '' },
      zipcode: '',
    },
    contactName: '',
    contactPhone: '',

    usersCount: '',
    vehiclesCount: '',
    driversCount: '',
    feePaymentAccount: {
      id: '',
      cashFlowCategory: { id: '' },
    },
    driverAllowancePaymentAccount: {
      id: '',
      cashFlowCategory: { id: '' },
    },
    finePaymentAccount: {
      id: '',
      cashFlowCategory: { id: '' },
    },
    deliverymanFeePaymentAccount: {
      id: '',
      cashFlowCategory: { id: '' },
    },
    deliverymanDriverAllowancePaymentAccount: {
      id: '',
      cashFlowCategory: { id: '' },
    },
    deliverymanFinePaymentAccount: {
      id: '',
      cashFlowCategory: { id: '' },
    },

    hubs: [],
  },
});

const plan = reactive({
  ability: {
    // createAlert: false,
    // createDepartment: false,
    // createUser: false,
  } as { [key: string]: boolean },
});

const isAttemptedCheck = ref(false);

export default function useAuth() {
  const { router } = useRouter();

  const {
    result, onResult, onError, refetch,
  } = useQuery(gql`
      query getMyInfo {
        me {
          id
          name
          avatarPath
          roles {
            id
            name
            permissions {
              id
              name
            }
          }
          hub {
            id
            name
            code
            hubType
            areas {
              id
              code
              name
            }
            lat
            long
          }
          company {
            id
            name

            subdomain
            package
            maxStorage

            userType

            startDate
            expireDate

            logoUrl
            backgroundUrl

            taxId
            billingAddress
            address {
              province {
                id
                nameInThai
              }
              district {
                id
                nameInThai
              }
              subdistrict {
                id
                nameInThai
              }
              zipcode
            }

            contactName
            contactPhone

            active

            colors {
              id
              key
              colorCode
            }

            vehiclesCount
            driversCount

            feePaymentAccount {
              id
              cashFlowCategory {
                id
              }
            }
            driverAllowancePaymentAccount {
              id
              cashFlowCategory {
                id
              }
            }
            finePaymentAccount {
              id
              cashFlowCategory {
                id
              }
            }
            deliverymanFeePaymentAccount {
              id
              cashFlowCategory {
                id
              }
            }
            deliverymanDriverAllowancePaymentAccount {
              id
              cashFlowCategory {
                id
              }
            }
            deliverymanFinePaymentAccount {
              id
              cashFlowCategory {
                id
              }
            }

            hubs(first: 100) {
              data {
                id
                name
                code
              }
            }
          }
        }
      }
    `, {}, {
    fetchPolicy: 'network-only',
  });

  onError((e: any) => {
    if (String(e).includes('Unauthenticated')) {
      isAttemptedCheck.value = true;
      console.warn('User is not logged in');
      router.push({ name: 'Login' });
      isAttemptedCheck.value = false;
    }
  });

  const myInfo = useResult(result, null, (data: any) => {
    isAttemptedCheck.value = true;
    return data.me;
  });

  watch(myInfo, (newValue) => {
    if (!newValue) return;
    me.id = newValue.id;
    me.name = newValue.name;
    me.avatarPath = newValue.avatarPath;
    me.hub = newValue.hub;
    me.hubId = parseInt(newValue.hub?.id, 10 || '-1') || -1;

    if (newValue.roles.length > 0) {
      me.role = newValue.roles[0].name;
      me.permissions = newValue.roles[0].permissions;
    }

    me.company.id = newValue.company.id;
    me.company.name = newValue.company.name;
    me.company.taxId = newValue.company.taxId;
    me.company.billingAddress = newValue.company.billingAddress;
    me.company.address = newValue.company.address;
    me.company.feePaymentAccount = newValue.company.feePaymentAccount;
    me.company.driverAllowancePaymentAccount = newValue.company.driverAllowancePaymentAccount;
    me.company.finePaymentAccount = newValue.company.finePaymentAccount;
    me.company.deliverymanFeePaymentAccount = newValue.company.deliverymanFeePaymentAccount;
    me.company.deliverymanDriverAllowancePaymentAccount = newValue.company.deliverymanDriverAllowancePaymentAccount;
    me.company.deliverymanFinePaymentAccount = newValue.company.deliverymanFinePaymentAccount;
    me.company.logoUrl = newValue.company.logoUrl || '/logo_fast.svg';
    me.company.backgroundUrl = newValue.company.backgroundUrl || '/img/background/bg-tms.png';
    me.company.contactName = newValue.company.contactName || '';
    me.company.contactPhone = newValue.company.contactPhone || '';
    me.company.hubs = newValue.company.hubs.data || [];
  });

  const isLoggedIn = computed(() => me.id !== -1);
  function hasPermission(permName: string) {
    // TODO: separate '*' (for ideavivat) and 'dotify.*' (for super admin)
    return computed(() => {
      if (!isAttemptedCheck.value) return false;
      const permArr = me.permissions.map((p: any) => p.name);
      if (
        permArr.indexOf('*') !== -1
        // && me.company.name === 'Idea Vivat'
      ) return true;
      // if (permArr.indexOf('dotify.*') !== -1 && permName !== '*') return true;
      if (permArr.indexOf(permName.toLowerCase()) !== -1) return true;
      if (permName.indexOf('.any') !== -1) return permArr.find((perm) => perm.indexOf(permName.replace('.any', '')) === 0) !== undefined;
      return false;
    }).value;
  }

  function refresh() {
    refetch();
  }

  // watchEffect(() => {
  //   console.log('isAttemptedCheck: ', isAttemptedCheck.value);
  //   console.log('isLoggedIn: ', isLoggedIn.value);
  //   console.log(JSON.stringify(me));
  // });

  return {
    me,
    plan,
    refresh,
    isAttemptedCheck,
    isLoggedIn,
    hasPermission,
  };
}
